export default "https://cdn-static.gokick.com/assets/be369b33e14920b1856d71de34d484ec78759d8a/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";